module.exports = __webpack_public_path__ + "static/media/kradziez.fba4c2b9.svg";